import React, { SVGProps } from 'react';

import {
  Apple,
  Google,
  SvgIconLight,
  Windows,
  Yahoo,
} from '@r-client/shared/ui/icons';

import { E_CALENDAR } from '../../constants';

interface ICalendarIconProps {
  type: E_CALENDAR;
  className?: string;
}

const iconMap = {
  [E_CALENDAR.ICAL]: Apple,
  [E_CALENDAR.GOOGLE]: Google,
  [E_CALENDAR.OUTLOOK]: Windows,
  [E_CALENDAR.OUTLOOK_ONLINE]: Windows,
  [E_CALENDAR.YAHOO]: Yahoo,
};

const getIconByType = (
  type: E_CALENDAR
): React.FC<React.PropsWithChildren<SVGProps<SVGSVGElement>>> | undefined => {
  return iconMap[type];
};

export const CalendarIcon: React.FC<
  React.PropsWithChildren<ICalendarIconProps>
> = ({ type, className }) => {
  const Component = getIconByType(type);
  return Component ? (
    <SvgIconLight className={className} icon={Component} />
  ) : null;
};
